
import ProviderService from "../../../../../../services/ProviderService";
import {isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";
import { OnTabKeyPress } from "../../../../../../utils/cssUtils";


export const NewMinimalExam = (props)=>{

    const physicalExamination = [
        {label:'General',name:'physical_examination_general',onKeyPress:(event)=>OnTabKeyPress(event,"","sitting_diastolic")},
        {label:'Skin',name:'physical_examination_skin'},
        {label:'Eyes',name:'physical_examination_eyes'},
        {label:'Ears',name:'physical_examination_ears'},
        {label:'Mouth / throat',name:'physical_examination_mouth_throat'},
        {label:'Cardiovascular',name:'physical_examination_cardiovascular'},
        {label:'Lungs / chest',name:'physical_examination_lungs_chest'},
        {label:'Abdomen',name:'physical_examination_abdomen'},
        {label:'Genito urinary sys / hernias',name:'physical_examination_genito_urinary'},
        {label:'Back / Spine',name:'physical_examination_back_spine'},
        {label:'Extremities / joints',name:'physical_examination_extremities_joints'},
        {label:'Neurological sys / reflexes',name:'physical_examination_neurological_sys_reflexes'},
        {label:'Gait',name:'physical_examination_gait'},
        {label:'Vascular system',name:'physical_examination_vascular_system'}];

        const patientHealthInformation = [
             { label: '1. Head/brain injuries or illnesses (e.g., concussion)', name: 'head_brain_injuries' },
    { label: '2. Seizures, epilepsy', name: 'seizures_epilepsy' },
    { label: '3. Eye problems (except glasses or contacts)', name: 'eye_problems' },
    { label: '4. Ear and/or hearing problems', name: 'ear_hearing_problems' },
    { label: '5. Heart disease, heart attack, bypass, or other heart problems', name: 'heart_disease' },
    { label: '6. Pacemaker, stents, implantable devices, or other heart procedures', name: 'pacemaker_stents_implantable_devices' },
    { label: '7. High blood pressure', name: 'high_blood_pressure' },
    { label: '8. High cholesterol', name: 'high_cholesterol' },
    { label: '9. Chronic (long-term) cough, shortness of breath, or other breathing problems', name: 'chronic_cough' },
    { label: '10. Kidney problems, kidney stones, or pain/problems with urination', name: 'kidney_problems' },
    { label: '11. Stomach, liver, or digestive problems', name: 'digestive_problems' },
    { label: '12. Diabetes or blood sugar problems Insulin used', name: 'diabetes_insulin' },
    { label: '13. Anxiety, depression, nervousness, other mental health problems', name: 'mental_problems' },
    { label: '14. Fainting or passing out', name: 'fainting_passing_out' },
    { label: '15. Dizziness, headaches, numbness, tingling, or memory loss', name: 'dizziness_headaches' },
    { label: '16. Unexplained weight loss', name: 'unexplained_weight_loss' },
    { label: '17. Stroke, mini-stroke (TIA), paralysis, or weakness', name: 'stroke_paralysis_weakness' },
    { label: '18. Missing or limited use of arm, hand, finger, leg, foot, toe', name: 'missing_limited_use_of_limbs' }, 
    { label: '19. Neck or back problems', name: 'neck_back_problems' },
    { label: '20. Bone, muscle, joint, or nerve problems', name: 'bone_muscle_joint_nerve_problems' },
    { label: '21. Blood clots or bleeding problems', name: 'blood_clots_bleeding' },
    { label: '22. Cancer', name: 'cancer' },
    { label: '23. Chronic (long-term) infection or other chronic diseases', name: 'chronic_infection' },
    { label: '24. Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring', name: 'sleep_disorders' },
    { label: '25. Have you ever had a sleep test (e.g., sleep apnea)?', name: 'had_sleep_test' },
    { label: '26. Have you ever spent a night in the hospital?', name: 'hospital_stay' },
    { label: '27. Have you ever had a broken bone?', name: 'had_broken_bone' },
    { label: '28. Have you ever used or do you now use tobacco?', name: 'tobacco_use' },
    { label: '29. Do you currently drink alcohol?', name: 'alcohol_use' },
    { label: '30. Have you used an illegal substance within the past two years?', name: 'illegal_substance_use' },
   { label: '31. Have you ever failed a drug test or been dependent on an illegal substance?', name: 'drug_test_failure' }
        ]; 
        
    const charts = [{
        type:'Grid',
        col:'col-md-3 px-0',
        className: 'non-dot-exam-scrollable',
        style: {
            position: "sticky",
            top: "0",
            zIndex: "1",
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            overflowX: "hidden"
        },
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },
        {
            type: "CompanyDetails",
            companyDetails: props.companyDetails
        },
        {
            type:"ResultSummary",
            results:[
               
            {
                normalMsg:'Patient History',
                abnormalMsg:'Patient History',
                label:'Patient',
                data:[
                    {label:'Surgeries',keyVal:'surgery_history',type:'yesorno'},
                    {label:'Medications',keyVal:'taking_medications',type:'yesorno'},
                    {label:'Health History',keyVal:patientHealthInformation.map(item => item.name),type:'ANY'},
                ],
            },
            {
                normalMsg:'Screening',
                abnormalMsg:'Screening',
                data:[
                    {label:'Pulse',keyVal:'pulse_rate_result'},
                    {label:'Blood Pressure',keyVal:'blood_pressure_result'},
                ],
            },   
            ]
            
        },
    ],
    },
    {
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                label: 'History',
                id: 'history',
                labelStyle: 'padding: 0;',
                data: [
                    {
                        label: 'Driver health Information',
                        labelStyle: "fw-semibold",
                        note: 'Check the body systems for abnormalities',
                        fields: [
                            {
                                label: 'Have you ever had surgery? If "yes," please list and explain below.',
                                type: 'RadioGroup',
                                labelWrap:false,
                                name: 'surgery_history',
                                col: 'col-12 border-0 ',
                                id: 'surgery_history',
                                options: [{ label: 'Yes', value: 'Yes', labelStyle: { color: 'red' }, inputStyle: { backgroundColor: 'red', borderColor: 'red' } }
                                    , { label: 'No', value: 'No' }
                                    , { label: 'Not Sure', value: 'Not Sure', labelStyle: { color: 'red' }, inputStyle: { backgroundColor: 'red', borderColor: 'red' } }],
                            },
                            {
                                label: '',
                                type: 'TextArea',
                                col: 'col-12 border-0',
                                disabled: true,
                                rules: [
                                    { rule: [{ field: 'surgery_history', value: 'Yes', operator: '===' }], action: 'ENABLE' },
                                    { rule: [{ field: 'surgery_history', value: 'Yes', operator: '===' }], action: 'REQUIRED', errorMessage: 'Please provide an explanation for the surgery.' }
                                ],
                                isLabel: false,
                                name: 'surgery_explanation',
                                id: 'surgery_explanation',
                                placeholder: "Add Comments"
                            },
                            {
                                label: "Are you currently taking medications (prescription, over-the-counter, herbal remedies, diet supplements)? If \"yes,\" please describe below.",
                                type: 'RadioGroup',
                                col: 'col-12 border-0',
                                labelWrap: false,
                                name: 'taking_medications',
                                id: 'taking_medications',
                                options: [{ label: 'Yes', value: 'Yes', labelStyle: { color: 'red' }, inputStyle: { backgroundColor: 'red', borderColor: 'red' } }
                                    , { label: 'No', value: 'No' }
                                    , { label: 'Not Sure', value: 'Not Sure', labelStyle: { color: 'red' }, inputStyle: { backgroundColor: 'red', borderColor: 'red' } }],
                            },
                            {
                                label: '',
                                type: 'TextArea',
                                col: 'col-12 border-0',
                                isLabel: false,
                                disabled: true,
                                rules: [
                                    { rule: [{ field: 'taking_medications', value: 'Yes', operator: '===' }], action: 'ENABLE' },
                                    { rule: [{ field: 'taking_medications', value: 'Yes', operator: '===' }], action: 'REQUIRED', errorMessage: 'Please provide an explanation for the medications.' }
                                ],
                                name: 'taking_medication_explanation',
                                id: 'taking_medication_explanation',
                                placeholder: "Add Comments"
                            },
                        ]
                    },
                    {
                        label: 'Do you have or have you ever had',
                        hideHeader: true, // Single header: "History" + Yes/No in NewYesOrNoFields header only
                        cardBodyClassName: 'p-0',
                        fields: [
                            {
                                col: 'col-12',
                                defaultBtnLabel: 'Set all to No',
                                type: 'NewYesOrNoFields',
                                label: 'Do you have or have you ever had',
                                options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }, { label: 'Not Sure', value: 'Not Sure' }],
                                defaultValues: patientHealthInformation.reduce((acc, itm) => {
                                    acc[itm.name] = 'No';
                                    return acc;
                                }, {}),
                                failedValue: ['Yes', 'Not Sure'],
                                list: patientHealthInformation,
                            },
                            {
                                label: '32. Other health condition(s) not described above ?',
                                type: 'RadioGroup',
                                name: 'other_conditions',
                                col: 'col-12 border-0',
                                id: 'other_conditions',
                                options: ['Yes', 'No', 'Not Sure'],
                            },
                           
                            {
                                label: '',
                                type: 'TextArea',
                                placeholder: "Add Comments",
                                col: 'col-12 border-0',
                                isLabel: false,
                                disabled: true,
                                rules: [{ rule: [{ field: 'other_conditions', value: 'Yes', operator: '===' }], action: 'ENABLE' },{ rule: [{ field: 'other_conditions', value: 'Yes', operator: '===' }], action: 'REQUIRED', errorMessage: 'Please describe the other health conditions.' }],
                                name: 'other_conditions_description',
                                id: 'other_conditions_description',
                            },
                            {
                                label: '33. Did you answer "yes" to any of questions 1-26? If so, please comment further on those health conditions below:',
                                type: 'RadioGroup',
                                name:'additional_comments',
                                id:'additional_comments',
                                labelWrap: false,
                                col: 'col-12 border-0',
                                options: ['Yes', 'No', 'Not Sure'],
                            },
                           
                            {
                                label: '',
                                type: 'TextArea',
                                placeholder: "Add Comments",
                                col: 'col-12 border-0',
                                isLabel: false,
                                disabled: true,
                               rules: [{ rule: [{ field: 'additional_comments', value: 'Yes', operator: '===' }], action: 'ENABLE' },{ rule: [{ field: 'additional_comments', value: 'Yes', operator: '===' }], action: 'REQUIRED', errorMessage: 'Please provide additional comments.' }],
                                name:'additional_comments_description',
                                id:'additional_comments_description',
                            },
                        ]
                    },
                    {
                        label:'Approval Signature & Date',
                        note:'I certify that the above information is accurate and complete.',
                        col:'col-12',
                        fields:[{
                            label:'Employee Signature',
                           isLabel:false,
                           type:'NewSignature',
                           col:'col-md-6 col-12 border-0',
                            name:'employee_signature',
                            id:'employee_signature',
                            // required:true,
                        },
                        {
                            label:'Date',
                            type:'NewDate',
                            isLabel:false,
                            col:'col-md-6 col-12 border-0',
                            id:'signatured_date',
                            name:'signatured_date',
                            // required:true,
                        },
                    ]
                    }
                ]
            },
            {
                label: 'Screening',
                id: 'screening',
                data: [
                    {
                        label:'Vitals Signs',
                        fields:[
                            {
                                label:'Blood Pressure Systolic (1st Reading)',
                                isLabel:false,
                                col: 'col-6 border-0 ',
                                type:'NewNumber',
                                placeholder:"Blood pressure",
                                rangeMax:139,
                                rangeMin:90,
                                name:'sitting_systolic',
                                id:'sitting_systolic',
                                onKeyPress:(event)=>OnTabKeyPress(event,"sitting_diastolic",""),
                                Max:3,
                            },
                            {
                                label:'Blood Pressure Systolic(2nd Reading)',
                                isLabel:false,
                                col: 'col-6 border-0 ',
                                type:'NewNumber',
                                placeholder:"Blood pressure",
                                rangeMax:139,
                                rangeMin:90,
                                name:'second_reading_systolic',
                                id:'second_reading_systolic',
                                Max:3,
                            },  
                            {
                                label:'Blood Pressure Diastolic (1st Reading)',
                                isLabel:false,
                                col: 'col-6 border-0 ',
                                type:'NewNumber',
                                placeholder:"Blood pressure",
                                rangeMin:60,
                                rangeMax:89,
                                name:'sitting_diastolic',
                                id:'sitting_diastolic',
                                onKeyPress:(event)=>OnTabKeyPress(event,"pulse_rate"),
                                Max:3,
                            },
                            {
                                label:'Blood Pressure Diastolic(2nd Reading)',
                                isLabel:false,
                                col: 'col-6 border-0 ',
                                type:'NewNumber',
                                placeholder:"Blood pressure",
                                rangeMin:60,
                                rangeMax:89,
                                name:'second_reading_diastolic',
                                id:'second_reading_diastolic',
                                Max:3,
                            },  
                            {
                                label:'Pulse Rate',
                                isLabel:false,
                                col: 'col-6 border-0 ',
                                type:'NewNumber',
                                name:'pulse_rate',
                                placeholder:"Pulse Rate",
                                rangeMin:60,
                                rangeMax:100,
                                id:'pulse_rate',
                                Max:3,
                            },
                            {
                                label:'Pulse Rhythm Regular',
                                type:'RadioGroup',
                                col: 'col-6 border-0 ',
                                name:'pulse_rhythm_regular',
                                id:'pulse_rhythm_regular',
                                options:[{label:'Yes',value:1},{label:'No',value:0}],
                            },
                            {
                                label:'Height  (Feet)',
                                placeholder:'Feet',
                                isLabel:false,
                                col: 'col-6 border-0 ',
                                type:'NewNumber',
                                name:'height_feet',
                                id:'height_feet',
                                Max:1,
                                
                            },
                            
                            {
                                label:'Inches',
                                isLabel:false,
                                placeholder:'Inches',
                                col: 'col-6 border-0 ',
                                type:'NewDecimal',
                                name:'height_inches',
                                id:'height_inches',
                                // Max:2,
                                
                            },
                            {
                                label:'Weight (In Pounds)',
                                isLabel:false,
                                placeholder:'Pounds',
                                type:'NewNumber',
                                name:'weight_pounds',
                                id:'weight_pounds',
                                col: 'col-6 border-0 ',
                                Max:3,
                                
                            },
                            {
                               label:'Neck Circumference (In)',
                               isLabel:false,
                               placeholder:'Circumference',
                               type:'NewDecimal',
                               name:'neck_circumference',
                               id:'neck_circumference',
                               col: 'col-6 border-0 ',
                            },
                            {
                                label:'Oxygen Saturation (SpO2)',
                                isLabel:false,
                                placeholder:'SpO2',
                                type:'NewNumber',
                                name:'oxygen_saturation',
                                id:'oxygen_saturation',
                                col: 'col-6 border-0 ',
                                Max:3,
                                
                            },
                        ]
                    },
                ]
            },
            {
                label: 'Exam',
                id: 'exam',
                labelStyle: "padding: 0;",
                data: [
                     {
                            label:'Activity Details - Health Information Review',
                            labelStyle: "fw-semibold",
                            // note:(type==='ProviderExam')?'Examination Report (to be filled out by the medical examiner)':'Examination Report (to be filled out by the Provider)',
                            headerRadio: {
                                name: 'health_information_review_radio',
                                id: 'health_information_review_radio',
                                options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]
                            },
                            fields:[
                                {
                                    label: "Review and discuss Employee/patient answers and any available medical records. Comment on the responses to the 'health history'. ",
                                    type:'Label',
                                    col:'col-12 border-0  text-dark',   
                                },
                                {
                                    label:'',
                                    type:'TextArea',
                                    labelWrap:false,
                                    name:'health_information_review',
                                    col:'col-12 border-0 ',
                                    id:'health_information_review',
                                    disabled: true,
                                    rules: [{ rule: [{ field: 'health_information_review_radio', value: 'Yes', operator: '===' }], action: 'ENABLE' }],
                                    isLabel: false,
                                    placeholder: "Add Comments"
                                }]
                        },  
                    {
                        label: 'Normal/Abnormal',
                        hideHeader: true, // Single header: "History" + Yes/No in NewYesOrNoFields header only
                        cardBodyClassName: 'p-0',
                        fields: [
                            {
                                col: 'col-12 border-0',
                                isLabel: false,
                                defaultBtnLabel: 'Set all to Normal',
                                type: 'NewYesOrNoFields',
                                label: 'Normal/Abnormal',
                                options: [{ label: 'Abnormal', value: 'Abnormal' }, { label: 'Normal', value: 'Normal' },],
                                defaultValues: physicalExamination.reduce((acc, itm) => {
                                    acc[itm.name] = 'Normal';
                                    return acc;
                                }, {}),
                                failedValue: ['Abnormal'],
                                list: physicalExamination,
                            },
                            {
                                label:"Comments",
                                type:'Label',
                                col:'col-12 border-0 text-dark',
                            },
                            {
                                label:"",
                                type:'TextArea',
                                labelWrap:false,
                                col:'col-12 border-0',
                                name:'physical_examination_comments',
                                id:'physical_examination_comments',
                                placeholder: "Add Comments",
                                isLabel: false,
                            },
                        ]
                    },
                ]
            },
            {
                label: 'Certification',
                id: 'certification',
                data: [
                    {
                        label: 'Medical Examiner Determination and Status', 
                        labelStyle: "fw-semibold",
                        fields: [
                            {
                                label: 'Medical Record',
                                type: 'TextInput',
                                name: 'medical_record',
                                id: 'medical_record',
                                col:"col-6 border-0"
                            },
                            {
                                label: 'Exam Date',
                                type: 'Date',
                                name: 'exam_date',
                                id: 'exam_date',
                                col:"col-6 border-0"
                            },
                            {
                                label: 'Employment Status',
                                type: 'MultiSelectDropDown',
                                ddKey: 'employmentstatus',
                                isToogle: true,
                                options: props.employmenStatusOption,
                                id: 'employment_status',
                                name: 'employment_status',
                                col:"col-6 border-0"
                            },
                            {
                                label: 'Provider',
                                type: 'SelectSearchList',
                                isAsync: true,
                                options: [],
                                autoPopulateFields: {
                                    // medical_examiners_certificate_expiration_date: 'unavailable_until',
                                },
                                loadCallBack: (val, callback) => fetchProviderList(val, props, callback),
                                name: 'provider',
                                id: 'provider',
                                col:"col-6 border-0",
                            },
                            {
                                label: 'Notes',
                                col: 'col-6 border-0',
                                type: 'TextArea',
                                name: 'notes',
                            },
                        ]
                    },
                    {
                        label: 'Review / Completion',
                        labelStyle: "fw-semibold",
                        col: 'col-12',
                        fields: [
                    {
                        type: 'ProviderSignOff',
                        col: 'col-12',
                        fields: [
                            {
                                label: 'Signature PIN',
                                name: 'provider_pin',
                                col: 'col-12',
                            },
                            {
                                label: 'Provider Signature',
                                isLabel: false,
                                type: 'NewSignature',
                                col: 'col-12 border-0',
                                name: 'provider_signature',
                                id: 'provider_signature',
                            },
                            { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                            // { label : "Suggested Result",disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                            // Existing options (commented for reference):
                            // { label : "Final Results", type: "SelectList", name: "status", col: "col-12",options: optionsToKeyValuePairs(['Not Started','Pending','Normal', 'Abnormal', 'Positive', 'Negative', 'Passed', 'Failed']),statusBasedColor: true },
                            // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                            {
                                label: "Final Results",
                                type: "SelectList",
                                name: "status",
                                col: "col-12",
                                options: optionsToKeyValuePairs(
                                    [
                                        "Not Started",
                                        "Pending",
                                        "Normal",
                                        "Abnormal",
                                        "Negative",
                                        "Positive",
                                        "Dispensed",
                                        "Administered",
                                        "Failed",
                                        "Passed",
                                        "Non-Negative",
                                        "Cancelled",
                                        "Inconclusive",
                                    ],
                                    false
                                ),
                                statusBasedColor: true,
                            },
                            {
                                label: "Activity Status",
                                type: "SelectList",
                                name: "activity_status",
                                col: "col-12",
                                options: optionsToKeyValuePairs(
                                    [
                                        "Not Started",
                                        "Pending",
                                        "Pending Lab Confirmation",
                                        "Pending MRO Confirmation",
                                        "Ready for Review",
                                        "Completed",
                                        "Cancelled",
                                    ],
                                    false
                                ),
                                statusBasedColor: true,
                            },
                        ],
                    },
                        
                        ]
                    },
                ]
            },
            {
                              label: 'Recap',
                              id: 'recap',
                              data: [
                                       {
                                           label: 'Do you have or have you ever had',
                                           labelStyle: "fw-semibold",
                                           fields: [
                                                     {
                                                        col: 'col-12',
                                                        type: 'YesAnswersDisplay',
                                                        label: 'Do you have or have you ever had',
                                                        list: patientHealthInformation,
                                                     },
                                                   ]
                                        },
                                    ]
            },
            {
                id: "Images",
                label: "Images",
                data: []
            }
        ]
    },
   ];
    const headers = [];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        pulse_rate_result:'Not Started',
        blood_pressure_result:'Not Started',
        
    };
    const buttons = {
        PDF:true
    }
    return {
        charts,
        defaultValue,
        buttons,
        headers,
        computationFunction: (formData, key) => ({
            ...computationRules(formData, key, patientHealthInformation),
            // ...computationRules1(formData, key),
        }),
    };
}


const computationRules = (formData,key,healthInfoList = [])=>{
    const pulse = isSet(formData.pulse_rate,'');
    const systolic = isSet(formData.sitting_systolic,'');
    const diastolic = isSet(formData.sitting_diastolic,'');
    let returnResult = {};

    const currentStatus = isSet(formData.status, "Not Started");
    const currentActivityStatus = isSet(formData.activity_status, "Not Started");
    if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
      returnResult.status = "Pending";
      returnResult.activity_status = "Pending";
    }
    if(key === 'status' && formData.status) {
      const status = formData.status;
      // Check if provider has signed (medical_examiner_signature_two exists and is not empty)
      const providerSigned = formData.provider_signature&& 
                            formData.provider_signature !== "" && 
                            formData.provider_signature !== null && 
                            formData.provider_signature !== undefined;
      
      switch(status) {
          case 'Not Started':
              returnResult.activity_status = 'Not Started';
              break;
          case 'Pending':
              returnResult.activity_status = 'Pending';
              break;
          case 'Normal':
              // If provider signed, set to Completed; otherwise Pending
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Abnormal':
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Negative':
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Positive':
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Dispensed':
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Administered':
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Failed':
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Passed':
              returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
              break;
          case 'Non-Negative':
              returnResult.activity_status = 'Pending Lab Confirmation';
              break;
          case 'Cancelled':
              returnResult.activity_status = 'Cancelled';
              break;
          case 'Inconclusive':
              returnResult.activity_status = 'Pending Lab Confirmation';
              break;
          default:
              // No change if status doesn't match any case
              break;
      }
    }
  
    if(key === 'provider_signature' && formData.status) {
      const status = formData.status;
      const providerSigned = formData.provider_signature && 
                            formData.provider_signature !== "" && 
                            formData.provider_signature !== null && 
                            formData.provider_signature !== undefined;
      
      // Completion statuses that should become "Completed" when provider signs
      const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
      
      if (completionStatuses.includes(status)) {
        returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
      }
    }
    if (healthInfoList.length > 0) {
        // Get all question keys from questions 1-25 (healthInfoList) and question 26 (other_conditions)
        const questionKeys = [...healthInfoList.map(item => item.name), 'other_conditions'];
        
        // Check if any question from 1-26 is "Yes"
        const hasAnyYesAnswer = questionKeys.some(qKey => formData[qKey] === 'Yes');
        
        // Check if all questions from 1-26 are "No"
        const allNoAnswers = questionKeys.every(qKey => formData[qKey] === 'No');
        
        // If any question is "Yes", set question 27 (additional_comments) to "Yes"
        if (hasAnyYesAnswer) {
            returnResult['additional_comments'] = 'Yes';
        }
        // If all questions are "No", set question 27 (additional_comments) to "No"
        if (allNoAnswers) {
            returnResult['additional_comments'] = 'No';
        }
    }

    let pulseRateResult = 'Not Started';
    if(pulse==''){
        pulseRateResult = 'Not Started'
    }else if (pulse >= 60 && pulse <= 100) {
        pulseRateResult =  'Normal';
    }else if(pulse!==''){
        pulseRateResult = 'Abnormal';
    }

    let bloodPressureResult = 'Not Started';
    if(systolic === '' && diastolic === ''){
        bloodPressureResult = 'Not Started'
    }else if (systolic === '' || diastolic === '') {
        bloodPressureResult = 'Pending';
    } else if ((systolic < 0 || systolic > 139) || (diastolic < 0 || diastolic >89)) {
        bloodPressureResult = 'Abnormal';
    } else {
        bloodPressureResult = 'Normal';
    }
    
    returnResult = {
        ...returnResult,
        pulse_rate_result:pulseRateResult,
        blood_pressure_result:bloodPressureResult
    }
    return returnResult;
}

export const fetchProviderList = async (val,props, callback=()=>{}) => {
    const {employeeDetails} = props;
    let optionArr = [];
    try{
        const data = await ProviderService.getProviderByClinicId(employeeDetails.clinic_id,{search:val});
        isSet(data,[]).map((item,itemIndex)=>{
            optionArr.push({
                label:isSet(item.first_name,'')+' '+isSet(item.last_name,''),
                value:item.provider_id,
                data:item,
                index:itemIndex
            })
        });
        callback(optionArr);
    }catch(e){

    }
    return optionArr;
  }